import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-200">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-file-list-3-line text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50 whitespace-nowrap">
                Sugargoo Spreadsheet
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              Your independent resource for Sugargoo Spreadsheet guides, product recommendations, shipping information and shopping tutorials.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-external-link-line"></i>
            </a>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">Quick Links</h4>
            <nav className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">Home</Link>
              <Link to="/article/sugargoo-spreadsheet-guide" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">Spreadsheet Guide</Link>
              <Link to="/article/sugargoo-shipping-cost-guide" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">Shipping Guide</Link>
              <Link to="/article/sugargoo-warehouse-guide" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">Warehouse Guide</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors">Main Website</a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">Resources</h4>
            <nav className="flex flex-col gap-2.5">
              <Link to="/article/sugargoo-spreadsheet-guide" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">Sugargoo Review</Link>
              <Link to="/article/sugargoo-shipping-cost-guide" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">Shipping Cost Guide</Link>
              <Link to="/article/sugargoo-warehouse-guide" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">Warehouse Guide</Link>
              <Link to="/article/sugargoo-coupon-discount-guide" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">Coupons &amp; Discounts</Link>
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">Disclaimer</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              This is an independent information website. We are not affiliated with or endorsed by Sugargoo. All product links redirect to our main website at kaspreadsheet.com.
            </p>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} Sugargoo Spreadsheet Hub. All rights reserved. Independent resource — not affiliated with Sugargoo.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-500 hover:text-background-300 transition-colors">Main Site</a>
            <Link to="/" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">Home</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}